<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-message-tab *ngIf="selectedTab?.subTypeDetail?.history?.message" [message]="selectedTab?.subTypeDetail?.history?.message" (clearMessage)="clearErrorMessage($event)">
</lms-message-tab>
<lms-loco-history-header [historyOps]='historyOps' [selectedTab]='selectedTab' [subTypes]='subTypes' (historyTypeValueChange)='historyTypeValueChangeListner($event);'></lms-loco-history-header>
<div class="clear"></div>
<div *ngIf="selectedTab && selectedTab?.subTypeDetail && selectedTab?.subTypeDetail?.history?.status  === 'blank'" class="page-helper-text">
    Search a Locomotive to display information.
</div>
<div *ngIf="selectedTab && selectedTab?.subTypeDetail && selectedTab?.subTypeDetail?.history?.status  === 'error'" class="page-helper-text color-red">
    Enter valid locomotive id
</div>
<lms-loco-history-details *ngIf="selectedTab && selectedTab?.subTypeDetail && selectedTab?.subTypeDetail?.history?.status  === 'loaded'" [history]='loadData' [historyOps]='{days: selectedTab?.tabSearchParameter?.spinnerVal, displayType: selectedTab?.tabSearchParameter?.displayType}'></lms-loco-history-details>